import React, { Component } from 'react';
import c3 from 'c3';
import 'c3/c3.css';

export default class Chart_Energy extends Component {
	constructor(props) {
		super(props);
		this.state = {

		}
	}

	componentDidMount() {
		this.generateChart();
		window.addEventListener('resize', this.generateChart);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.generateChart);
	}

	generateChart = () => {
		let width = this.props.chart_width;
		let height = this.props.chart_height;
		let chart_data = this.props.chart_data;

		/*
		 * rotates the x and y axis. if set to true, x and y axis will switch places
		 * is_rotated true = screen vertical
		 * is_rotated false = screen horizontal
		 * https://c3js.org/samples/axes_rotated.html
		 */
		let is_rotated = false;
		if (height > width) is_rotated = true;

		/*
		 * For rotating x-axis
		 * When rotated, we need to reverse the order of the chart_data. i.e. time: 00:00 should start from bottom
		 * **Not used currently
		 */
		/*if(is_rotated){
			for(let index in chart_data){
				let key = chart_data[index][0];
				let row_data = chart_data[index].slice(1, chart_data[index].length);
				
				// When rotated, there's no API for inverting timeseries
				// As such, we need to convert time to string for display, and reverse the order
				// currently data input timestamp is a string. Eg. '2020-12-31 00:00:00'
				if(key == 'x'){
					for(let i in row_data){
						let timestamp = row_data[i];
						if(this.props.period == 'day'){
							row_data[i] = timestamp.substring(timestamp.indexOf(' ')+1, timestamp.indexOf(' ')+6);
						}
					}
				}
				
				row_data = row_data.reverse();
				row_data.unshift(key);
				chart_data[index] = row_data;
			}
		}*/

		// Padding for the chart, we need padding so to show the axis labels
		// https://c3js.org/samples/options_padding.html
		let padding = { top: 0, right: 65, bottom: 0, left: 45 }; // screen horizontal
		if (is_rotated) padding = { top: 0, right: 20, bottom: 0, left: 45 }; // screen vertical

		// Time series display format
		// https://c3js.org/samples/timeseries.html
		let display_time_format = '%H:%M';
		if (this.props.period == 'month') display_time_format = '%d-%b';
		else if (this.props.period == 'year') display_time_format = '%b';

		// Stacked bar chart group i.e. data in each group will appear stacked
		// https://c3js.org/samples/chart_bar_stacked.html
		let groups = [];
		let group = [];
		let key_total = this.props.receiver.getString('total_consumption');

		// Additional y axis 'y2' for total
		// https://c3js.org/samples/axes_y2.html
		let axes = {};

		// Y and Y2-axis labels
		let y_label = this.props.receiver.getString('energy_consumption') + " kWh";
		let y2_label = this.props.receiver.getString('total_consumption') + " kWh";

		if (this.props.report_type == 'energy_management') {
			if (is_rotated) {
				// swap labels if rotated
				// If rotating x-axis, need to comment this
				y_label = this.props.receiver.getString('total_consumption') + " kWh";
				y2_label = this.props.receiver.getString('energy_consumption') + " kWh";
			}
		} else if (this.props.report_type == 'water_management') {
			y_label = this.props.receiver.getString('water_consumption') + " m³";
			y2_label = this.props.receiver.getString('total_consumption') + " m³";

			if (is_rotated) {
				// swap labels if rotated
				// If rotating x-axis, need to comment this
				y_label = this.props.receiver.getString('total_consumption') + " m³";
				y2_label = this.props.receiver.getString('water_consumption') + " m³";
			}
		}

		let energy_generator_exist = false;

		for (let data of this.props.chart_data) {
			// Check if user enabled energy generator
			if (data[0] == 'Energy Generator') {
				energy_generator_exist = !energy_generator_exist;
			}

			if (data[0] != 'x' && data[0] != key_total) {
				group.push(data[0]);
				axes[data[0]] = 'y';
				// swap axis if rotated
				// If rotating x-axis, need to comment this
				if (is_rotated) axes[data[0]] = 'y2';
			}
		}
		groups.push(group);
		axes[key_total] = 'y2';
		// swap axis if rotated
		// If rotating x-axis, need to comment this
		if (is_rotated) axes[key_total] = 'y';

		// Grid line to show line for energy consumption at 0
		// https://c3js.org/samples/grid_y_lines.html
		let grid = { y: { lines: [{ value: 0 }] } };
		if (is_rotated) {
			grid = { y: { lines: [{ value: 0, axis: 'y2', position: 'start' }] } };
		}

		/*
		 * Can have multiple type of chart(eg. line and stacked bar chart
		 * define which data belongs in each type. 
		 * https://c3js.org/samples/chart_combination.html
		 */
		let types = {};
		types[key_total] = 'line';

		let chart = c3.generate({
			bindto: '#chart',
			padding: padding,
			size: {
				width: width,
				height: height,
			},
			data: {
				x: 'x',
				xFormat: '%Y-%m-%d %H:%M:%S', // Input time series format
				columns: chart_data,
				type: 'bar',
				types: types,
				groups: groups,
				axes: axes,
				order: null,
			},
			grid: grid,
			bar: {
				width: {
					ratio: 0.5 // this makes bar width 50% of length between ticks
				}
			},
			axis: {
				rotated: is_rotated,
				x: {
					type: 'timeseries',
					tick: {
						format: display_time_format // Display time series format
					}
				},
				y: {
					label: {
						text: y_label,
						position: 'outer-middle'
					},
					tick: {
						format: function (d) {
							if (Math.abs(d) >= 1000000) {
								return (d / 1000000).toFixed(1) + 'M';
							} else if (Math.abs(d) >= 1000) {
								return (d / 1000).toFixed(1) + 'K';
							} else if (Math.abs(d) >= 100) {
								d = Math.round(d / 100) * 100;
								return d;
							} else {
								return d.toFixed(3);
							}
						},
						count: 3,
					},
					padding: {
						bottom: energy_generator_exist ? 20 : undefined
					}
				},
				y2: {
					show: true,
					tick: {
						format: function (d) {
							if (Math.abs(d) >= 1000000) {
								return (d / 1000000).toFixed(1) + 'M';
							} else if (Math.abs(d) >= 1000) {
								return (d / 1000).toFixed(1) + 'K';
							} else if (Math.abs(d) >= 100) {
								d = Math.round(d / 100) * 100;
								return d;
							} else {
								return d.toFixed(3);
							}
						},
						count: 3
					},
					label: {
						text: y2_label,
						position: 'outer-middle',
					},
					padding: {
						bottom: energy_generator_exist ? 20 : undefined
					}
				}
			},
			tooltip: {
				format: {
					value: function (d) {
						return d.toFixed(2);
					}, // this format apply to both y and y2
				}
			},

			legend: { // Give padding to prevent chart legends overlapping
				padding: 20
			}
		})

		return chart;
	}

	render() {
		let style = {};
		style = Object.assign(style, this.props.style);

		return (
			<div id="chart" style={style} />
		);
	}
}